import React from "react";
import { Link } from "react-router-dom";
import { Form, Button, Col, Divider } from "antd";
import FormInput from "../../common/FormInput";
import AlertNotice from "../../common/Alert";

const LoginPage = ({
  Fields,
  getFieldDecorator,
  handleSubmit,
  authError,
  errorType,
  socialLogin
}) => {
  return (
    <div>
      <Col span={8} offset={8} style={{ marginTop: "10%" }}>
        <div style={{ textAlign: "center" }}>
          <h2>Mail Hopper</h2>
          <p>Sign in to start sending email.</p>
          {authError ? <AlertNotice message={authError} type={errorType} /> : null}
        </div>
        <Form
          onSubmit={handleSubmit}
          className="campaign-form"
          style={{ marginTop: 40 }}
        >
          {Fields &&
            Fields.map((field, index) => (
              <Form.Item key={index}>
                <FormInput
                  field={field}
                  getFieldDecorator={getFieldDecorator}
                />
              </Form.Item>
            ))}

          <Form.Item>
            <Button
              size="large"
              style={{ width: "100%" }}
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Log In
            </Button>
            <Button style={{ marginBottom: 20, marginLeft: -16 }} type="link">
              Forgot Password
            </Button>
          </Form.Item>
        </Form>
        <Divider style={{ marginTop: -40 }}>or</Divider>
        <Button
          size="large"
          style={{ width: "48%" }}
          type="danger"
          htmlType="button"
          onClick={() => socialLogin("google")}
        >
          Google
        </Button>
        <Button
          size="large"
          style={{ width: "48%", float: "right" }}
          type="default"
          htmlType="button"
          onClick={() => socialLogin("facebook")}
        >
          Facebook
        </Button>
        <p style={{ marginTop: 15 }}>
          Do not have an account?
          <Button type="link">
            <Link to="/register">Sign Up Now</Link>
          </Button>
        </p>
      </Col>
    </div>
  );
};

export default LoginPage;
